import { StepperSelectionEvent } from '@angular/cdk/stepper'
import { Directive, HostListener } from '@angular/core'
import { MatStepper } from '@angular/material/stepper'

/**
 * Fix for stepper not scrolling to top when changing steps
 * See: https://github.com/angular/components/issues/8881
 */

@Directive({
  selector: 'mat-stepper',
})
export class MatStepperScrollToTopDirective {
  constructor(private stepper: MatStepper) {}

  @HostListener('selectionChange', ['$event'])
  selectionChanged(selection: StepperSelectionEvent) {
    const stepId = this.stepper._getStepLabelId(selection.selectedIndex)
    const stepElement = document.getElementById(stepId)
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth',
        })
      })
    }
  }
}
